module.exports = __webpack_public_path__ + "static/credit-4f609b3a5be11d25658a16731a0b56f4.png";